<script setup lang="ts">
import WarningIcon from '@/assets/icons/WarningIcon.vue';
import { useLocale } from '@/composables/useLocale';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { EFileUploadError } from 'common/enum/file.upload.enum';
import { formatFileSize, formatSupportedFileTypes, type TFileUploadError } from 'common/utils/file.utils';

const { t } = useI18n();
const { formattingLocale } = useLocale();

const props = defineProps<{
  error: TFileUploadError;
  maxUploadSizeBytes: number;
  supportedFileTypes: string[];
}>();

const label = computed<string | null>(() => {
  switch (props.error) {
    case EFileUploadError.SIZE:
      return t('general.uploadSizeExceeded', {
        size: formatFileSize(props.maxUploadSizeBytes, formattingLocale.value),
      });
    case EFileUploadError.TYPE:
      return t('general.uploadTypeInvalid', {
        fileTypes: formatSupportedFileTypes(props.supportedFileTypes),
      });
    default:
      return null;
  }
});
</script>

<template>
  <div v-if="label" class="mt-sm flex items-start gap-sm">
    <WarningIcon class="size-icon-xs shrink-0 text-warning" />
    <span class="text-xs text-warning">{{ label }}</span>
  </div>
</template>
